document.addEventListener("DOMContentLoaded", () => {
    const videoWrappers = document.querySelectorAll('.component-video');

    if (!videoWrappers.length) return;

    videoWrappers.forEach(videoWrapper => {
        const videoElement = videoWrapper.querySelector('.component-video__video');
        const playButton   = videoWrapper.querySelector('.component-video__play');
        const videoPoster  = videoWrapper.querySelector('.component-video__poster');

        const toggleVisibility = (isPlaying) => {
            videoPoster.classList.toggle('hidden', isPlaying);
            playButton.classList.toggle('hidden', isPlaying);
            videoElement.classList.toggle('hidden', !isPlaying);
            videoWrapper.classList.toggle('playing', isPlaying);
        };

        // Handle manual play button click
        playButton.addEventListener('click', () => {
            toggleVisibility(true);
            videoElement.play();
        });

        // Reset UI when the video is paused or ended
        const resetVideoUI = () => toggleVisibility(false);
        videoElement.addEventListener('pause', resetVideoUI);
        videoElement.addEventListener('ended', resetVideoUI);
    });
});